/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateLegalEntityPaymentMethodRequestPaymentMethod
 */
export interface UpdateLegalEntityPaymentMethodRequestPaymentMethod {
}

/**
 * Check if a given object implements the UpdateLegalEntityPaymentMethodRequestPaymentMethod interface.
 */
export function instanceOfUpdateLegalEntityPaymentMethodRequestPaymentMethod(value: object): value is UpdateLegalEntityPaymentMethodRequestPaymentMethod {
    return true;
}

export function UpdateLegalEntityPaymentMethodRequestPaymentMethodFromJSON(json: any): UpdateLegalEntityPaymentMethodRequestPaymentMethod {
    return UpdateLegalEntityPaymentMethodRequestPaymentMethodFromJSONTyped(json, false);
}

export function UpdateLegalEntityPaymentMethodRequestPaymentMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLegalEntityPaymentMethodRequestPaymentMethod {
    return json;
}

export function UpdateLegalEntityPaymentMethodRequestPaymentMethodToJSON(json: any): UpdateLegalEntityPaymentMethodRequestPaymentMethod {
    return UpdateLegalEntityPaymentMethodRequestPaymentMethodToJSONTyped(json, false);
}

export function UpdateLegalEntityPaymentMethodRequestPaymentMethodToJSONTyped(value?: UpdateLegalEntityPaymentMethodRequestPaymentMethod | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

